import { Input } from '@thanx/uikit/input'
import { Text } from '@thanx/uikit/text'
import { useCreateUserListMutation } from 'api/userLists'
import Modal from 'components/ModalContainer'
import { buildTranslate } from 'locales'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeCreateModal, selectCreateModalOpen } from 'slices/userLists'

const t = buildTranslate('user_lists.create_modal')

const CreateListModal: React.FC = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(state => selectCreateModalOpen(state as any))
  const [name, setName] = useState('')
  const [createList, { isLoading }] = useCreateUserListMutation()

  const handleClose = () => {
    setName('')
    dispatch(closeCreateModal())
  }

  const handleCreate = async () => {
    if (!name.trim() || isLoading) return
    try {
      await createList({ name: name.trim() }).unwrap()
      setName('')
      dispatch(closeCreateModal())
    } catch {
      // API error — RTK Query will expose error state if needed
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      title={t('title')}
      proceedText={t('create')}
      onProceed={handleCreate}
      onClose={handleClose}
      canProceed={!!name.trim() && !isLoading}
      isLoading={isLoading}
    >
      <div className="mt-m mb-xs">
        <Text.BodyText4 bold>{t('name_label')}</Text.BodyText4>
      </div>
      <Input
        size="default"
        placeholder={t('name_placeholder')}
        value={name}
        onChange={newName => setName(newName)}
        overrides={{
          Input: {
            style: () => ({
              fontSize: '16px !important',
            }),
          },
        }}
      />
    </Modal>
  )
}

export default CreateListModal
